import React from 'react';
import { CheckList } from './CheckList';
import { audience, useCases } from '../data/offer';
export function WhoItsFor() {
  return <section className="py-24 px-4 bg-white" data-id="element-360" data-mp="11bglm8lw1ths">
      <div className="max-w-5xl mx-auto" data-id="element-361" data-mp="15ev373ph6hxc">
        <h2 className="text-3xl md:text-5xl font-display font-extrabold text-navy text-center mb-12" data-id="element-362" data-mp="15fwpy5fussuw">
          Who Is Mountain Bike Coach Ready For?
        </h2>
        <div className="grid md:grid-cols-2 gap-10 md:gap-0 md:divide-x md:divide-line" data-id="element-363" data-mp="dnp7r0kp98ee">
          <div className="md:pr-12" data-id="element-364" data-mp="horcty1aseoa">
            <CheckList list={{
            label: 'This system can support:',
            items: audience
          }} data-id="element-365" data-mp="hq2cpmrmh2a4" />
          </div>
          <div className="md:pl-12" data-id="element-366" data-mp="mnc2j3ixbfyh">
            <CheckList list={{
            label: 'Use it for:',
            items: useCases
          }} data-id="element-367" data-mp="mmapitickje4" />
          </div>
        </div>
      </div>
    </section>;
}